<template>
    <div>
        <NuxtLayout>
            <ClientOnly>
                <Suspense ref="suspenseRef">
                    <template #default>
                        <NuxtErrorBoundary @error="handleError">
                            <NuxtPage />
                        </NuxtErrorBoundary>
                    </template>
                    <template #fallback>
                        <Loader title="One moment please" text="Working" />
                    </template>
                </Suspense>
                <Notice />
            </ClientOnly>
        </NuxtLayout>
    </div>
</template>

<script setup>
    const handleError = (error) => {
        // Redirect to the custom error page with error details
        console.error(error);
        navigateTo({ path: '/error' });
    };
    const router = useRouter();
    const routeName = computed(() => router.currentRoute.value.name);
    const runtimeConfig = useRuntimeConfig();

   useHead({
    script: [
           {
               children: `
                const allowedHosts = new Set([
                    'consultation.ultimateperformance.com',
                    'www.consultation.ultimateperformance.com',
                    // // To Test It On DEV Environment, Uncomment The Following Lines
                    // 'consultation-dev.ultimateperformance.com',
                    // 'www.consultation-dev.ultimateperformance.com',
                    // // To Test It On Localhost, Uncomment The Following Lines
                    // 'http://localhost/',
                    // 'localhost',
                ]);

                if (allowedHosts.has(location.hostname)) {
                    const loadHyros = () => {
                        if (document.getElementById('hyros-script')) {
                            return;
                        }

                        const script = document.createElement('script');

                        script.id = 'hyros-script';
                        script.type = 'text/javascript';
                        script.async = true;

                        script.src = '${runtimeConfig.public.hyrosUniversalScriptUrl}?ph=${runtimeConfig.public.hyrosUniversalScriptPh}&tag=!clicked&spa=true&ref_url=' + encodeURIComponent(window.location.href);

                        document.head.appendChild(script);
                    };

                    if ('requestIdleCallback' in window) {
                        requestIdleCallback(loadHyros, { timeout: 2000 });
                    } else {
                        setTimeout(loadHyros, 1000);
                    }
                }
    `
           }
       ],
});
</script>

<style scoped lang="scss">
    #existing-booking {
        background-color: #f3f3f3 !important;
    }
</style>
